import React, { useEffect, useState } from "react";
import clone from 'lodash.clonedeep';
import { Button, Glyphicon, Modal } from "react-bootstrap";
import { createQuestionTheme, updateQuestionTheme, reorderQuestionThemes, deleteQuestionTheme } from "api";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import MoveIcon from "../../Widgets/components/Icons/MoveIcon";
import FormControlLanguage from "../../../UI/FormControlLanguage";

export default ({ themes, updateThemes, updateTheme, show, onHide = () => { }, eventPassword }) => {

    const handleReorder = (result) => {
        if (!result.destination) {
            return;
        }

        const reordered = reorder(
            themes,
            result.source.index,
            result.destination.index
        );
        updateThemes(reordered)
        reorderQuestionThemes(eventPassword, { sortOrder: reordered.map(({ id }) => id) })
    }

    function reorder(list, startIndex, endIndex) {
        const result = clone(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result.map((item, order) => ({ ...item, order }));
    }

    const handleAddTheme = () => createQuestionTheme(eventPassword, { order: themes.reduce((order, cur) => Math.max(order, cur.order), 0) + 1 });
    const handleUpdateTheme = (theme) => updateQuestionTheme(eventPassword, theme);
    const handleDeleteTheme = (themeID) => deleteQuestionTheme(eventPassword, themeID);

    return <Modal
        show={show}
        onHide={onHide}
    >
        <Modal.Header closeButton>
            <Modal.Title>
                Темы вопросов
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <DragDropContext onDragEnd={handleReorder}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {themes.slice().sort((a, b) => a.order - b.order).map((theme, index) => (
                                <Draggable
                                    key={theme.id}
                                    draggableId={`${theme.id}`}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                                ...provided.draggableProps.style, padding: '4px 4px 4px 12px',
                                                display: 'flex',
                                                height: '44px',
                                                marginBottom: '0.75rem',
                                                display: 'flex',
                                                alignItems: 'center',
                                                border: '1px solid #ccc',
                                                borderRadius: '5px',
                                                gap: '0.5rem'
                                            }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flex: 1 }}>
                                                <div style={{ minWidth: 20 }}>
                                                    <MoveIcon />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <FormControlLanguage
                                                        type="text"
                                                        values={{
                                                            ru: theme.titleRu || '',
                                                            en: theme.titleEn || '',
                                                        }}
                                                        onChange={{
                                                            ru: (e) => updateTheme(theme.id, { titleRu: e.target.value }),
                                                            en: (e) => updateTheme(theme.id, { titleEn: e.target.value }),
                                                        }}
                                                        onBlur={() => handleUpdateTheme(theme)}
                                                    />
                                                </div>
                                            </div>
                                            <Button bsStyle="danger" onClick={() => handleDeleteTheme(theme.id)}>
                                                <Glyphicon glyph="trash" />
                                            </Button>
                                        </div>

                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
            <Button bsStyle="success" onClick={handleAddTheme}>
                <Glyphicon glyph="plus" />
                {" "}Добавить
            </Button>
        </Modal.Body>
    </Modal>
}